/*
    Modal Política de Privacidade (site todo — roda pelo main.js)

    Abre a partir de QUALQUER a[href="#politica-de-privacidade"]: o link fixo do
    footer e o link injetado pelo banner de cookies da TermsFeed (por isso o
    listener é delegado no document, em fase de captura — também garante o
    preventDefault ANTES do handler de âncoras do page_home.js, que senão
    tentaria um lenis.scrollTo no hash).

    Scroll lock: body.privacy-modal-open (CSS) + window.lenis.stop()/start()
    quando a LP expõe a instância (page_home.js). O corpo do modal tem
    data-lenis-prevent p/ rolar nativamente com o Lenis ativo.
*/
export default function PrivacyModal() {
    const modal = document.getElementById('privacyModal');
    if (!modal) return;

    const body = modal.querySelector('.privacy-modal__body');
    const closeBtn = document.getElementById('privacyModalClose');

    const setOpen = (open) => {
        modal.classList.toggle('is-open', open);
        modal.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('privacy-modal-open', open);
        if (window.lenis) open ? window.lenis.stop() : window.lenis.start();
        if (open && body) body.scrollTop = 0;
    };

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('a[href="#politica-de-privacidade"]');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
    }, true);

    if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));

    // clique no overlay (fora do painel) fecha
    modal.addEventListener('click', (e) => {
        if (e.target === modal) setOpen(false);
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) setOpen(false);
    });
}
